import React from "react";

function IllustrationRdcListingPromotion() {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 96">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M99.25 44.5c0-7.542-6.327-13.75-14.25-13.75v-3.5c9.75 0 17.75 7.671 17.75 17.25s-8 17.25-17.75 17.25v-3.5c7.923 0 14.25-6.208 14.25-13.75Z"
        className="fill-primary"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M106.25 45c0-11.736-9.514-21.25-21.25-21.25v-3.5c13.669 0 24.75 11.081 24.75 24.75S98.669 69.75 85 69.75v-3.5c11.736 0 21.25-9.514 21.25-21.25Z"
        className="fill-primary"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M84.535 16.527c.541.313.875.89.875 1.515v52.426a1.75 1.75 0 0 1-2.625 1.516L60.489 59.112H33.106c-8.205 0-14.856-6.652-14.856-14.857 0-8.205 6.651-14.856 14.856-14.856H60.49l22.296-12.872a1.75 1.75 0 0 1 1.75 0Zm-2.625 4.546L61.832 32.664a1.75 1.75 0 0 1-.875.235h-27.85c-6.273 0-11.357 5.084-11.357 11.356s5.084 11.357 11.356 11.357h27.851c.308 0 .61.08.875.234L81.91 67.437V21.073Z"
        className="fill-secondary"
      />
      <path
        d="M83.66 35.83a5.617 5.617 0 0 1 5.617 5.617V48a5.617 5.617 0 0 1-5.617 5.617V35.83Zm-44 22.468h11.234l-4.132 17.354a3 3 0 0 1-2.919 2.305h-5.066a3 3 0 0 1-2.919-3.694l3.802-15.965Z"
        className="fill-secondary"
      />
    </svg>
  );
}

export default IllustrationRdcListingPromotion;
